export default "__VITE_ASSET__I0MQirEd__"